import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    input,
    viewChild,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { HocusDirective } from '@interacta-shared/ui';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-ai-shared-input',
    templateUrl: './ai-shared-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, HocusDirective, TranslatePipe],
})
export class AISharedInputComponent implements AfterViewInit {
    control = input.required<FormControl>();
    readonly hasLeadingAction = input(false);
    readonly maxLength = input<number | null>(null);

    textArea = viewChild<ElementRef<HTMLTextAreaElement>>('textArea');

    readonly MIN_INPUT_ROWS = 1;
    readonly MAX_INPUT_ROWS = 6;

    ngAfterViewInit(): void {
        requestAnimationFrame(() => {
            this.textArea()?.nativeElement?.focus();
            this.resetHeight();
        });
    }

    onEnterPressed($event: Event): void {
        $event.preventDefault();
        this.resetHeight();
    }

    refreshHeight(): void {
        const el = this.textArea()?.nativeElement;
        if (el) {
            // The three statements below run synchronously in the same JS task,
            // so the browser batches all layout changes into a single paint —
            // no flicker is visible to the user. The cost is two forced reflows
            // (one read + one write), which is acceptable given that this fires
            // only on user input events, never on animation frames.
            //
            // overflow:hidden must be set before collapsing to 'auto': without it
            // the browser reserves scrollbar space when content overflows, which
            // narrows the text area, causes an extra line-wrap, and inflates
            // scrollHeight by one line — leaving a blank row after the resize.
            el.style.overflow = 'hidden';
            el.style.height = 'auto';
            el.style.height = `${el.scrollHeight}px`;
            el.style.overflow = '';
        }
    }

    resetHeight(): void {
        const el = this.textArea()?.nativeElement;
        if (el) {
            el.style.height = '1lh';
        }
    }
}
